<template>
  <PlaceholderPantalla
    titulo="Reportes de Inventario"
    subtitulo="Análisis y reportes del inventario"
    descripcion="Centro de reportes de inventario con múltiples análisis: valuación de inventario, rotación de productos, análisis ABC, mermas y desperdicios, productos de lento movimiento, próximos a vencer, y mucho más. Exporta reportes en Excel y PDF para auditorías y toma de decisiones."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../../Finanzas/PlaceholderPantalla.vue'

const funcionalidades = [
  'Reporte de Valuación de Inventario (valor total del stock)',
  'Análisis de Rotación de Inventario (qué tan rápido se mueve)',
  'Clasificación ABC (productos más valiosos vs menos)',
  'Reporte de Mermas y Desperdicios con análisis de causas',
  'Productos de Lento Movimiento (sin ventas en X días)',
  'Productos Próximos a Vencer con alertas',
  'Historial de Movimientos por Producto',
  'Reporte de Niveles de Stock (mínimo, máximo, actual)',
  'Análisis de Exactitud de Inventario (% de precisión)',
  'Comparativo de Compras por Período',
  'Análisis de Proveedores (mejor precio, mejor servicio)',
  'Productos sin Stock (agotados)',
  'Costo de Inventario Promedio',
  'Gráficas de tendencias de consumo',
  'Exportar todos los reportes a Excel/PDF'
]

const datosManejados = [
  'Tipo de reporte seleccionado',
  'Período de análisis (fechas)',
  'Filtros (categoría, almacén, proveedor)',
  'Valuación total del inventario',
  'Costo promedio de inventario',
  'Rotación de inventario (veces por año)',
  'Clasificación ABC de productos',
  'Total de mermas por período',
  'Causas de mermas clasificadas',
  'Productos sin movimiento',
  'Días sin movimiento',
  'Productos próximos a caducar',
  'Exactitud de inventario (%)',
  'Diferencias en conteos',
  'Gráficas y visualizaciones',
  'Formato de exportación (Excel, PDF, CSV)'
]
</script>
